import React from "react";
import { Plus, Edit2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const ResourcesDialog = ({
  open, onOpenChange,
  resources,
  resourceForm, setResourceForm,
  editingResource, setEditingResource,
  addResource, updateResource,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[85vh]">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Resources</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex gap-2">
            <Input
              data-testid="resource-name-input"
              placeholder={editingResource ? "Editing..." : "Resource name"}
              value={resourceForm.name}
              onChange={(e) => setResourceForm({ ...resourceForm, name: e.target.value })}
              className="h-10 rounded-xl flex-1"
              disabled={!!editingResource}
            />
            <Input
              data-testid="resource-quantity-input"
              type="number"
              placeholder="Qty"
              value={resourceForm.quantity}
              onChange={(e) => setResourceForm({ ...resourceForm, quantity: e.target.value })}
              className="h-10 rounded-xl w-20"
            />
            {editingResource ? (
              <div className="flex gap-1">
                <Button data-testid="save-resource-btn" onClick={updateResource} size="sm" className="h-10 rounded-xl">Save</Button>
                <Button onClick={() => { setEditingResource(null); setResourceForm({ name: "", quantity: "" }); }} size="sm" variant="outline" className="h-10 rounded-xl">Cancel</Button>
              </div>
            ) : (
              <Button data-testid="add-resource-btn" onClick={addResource} size="sm" className="h-10 rounded-xl">
                <Plus className="w-4 h-4 mr-1" /> Add
              </Button>
            )}
          </div>

          <div className="space-y-2">
            {resources.map((resource) => (
              <div key={resource.resource_id} className="flex items-center justify-between p-3 bg-slate-50 rounded-xl">
                <div>
                  <p className="font-medium text-sm">{resource.name}</p>
                  <p className="text-xs text-slate-500">Quantity: {resource.quantity}</p>
                </div>
                <Button
                  onClick={() => { setEditingResource(resource); setResourceForm({ name: resource.name, quantity: resource.quantity.toString() }); }}
                  size="sm" variant="outline" className="rounded-full"
                >
                  <Edit2 className="w-3 h-3" />
                </Button>
              </div>
            ))}
            {resources.length === 0 && <p className="text-center text-slate-500 py-4 text-sm">No resources added</p>}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ResourcesDialog;
